import { render, staticRenderFns } from "./CalendarConfig.vue?vue&type=template&id=367ef231&"
import script from "./CalendarConfig.vue?vue&type=script&lang=js&"
export * from "./CalendarConfig.vue?vue&type=script&lang=js&"
import style0 from "./CalendarConfig.vue?vue&type=style&index=0&id=367ef231&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports